import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=3a18dda4&scoped=true&"
import script from "./Success.vue?vue&type=script&lang=js&"
export * from "./Success.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=3a18dda4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a18dda4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a18dda4')) {
      api.createRecord('3a18dda4', component.options)
    } else {
      api.reload('3a18dda4', component.options)
    }
    module.hot.accept("./Success.vue?vue&type=template&id=3a18dda4&scoped=true&", function () {
      api.rerender('3a18dda4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/pages/setup/Success.vue"
export default component.exports